import { render, staticRenderFns } from "./HeatingTank.vue?vue&type=template&id=5c70b74c&scoped=true&"
import script from "./HeatingTank.vue?vue&type=script&lang=js&"
export * from "./HeatingTank.vue?vue&type=script&lang=js&"
import style0 from "./HeatingTank.vue?vue&type=style&index=0&id=5c70b74c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c70b74c",
  null
  
)

export default component.exports